import { useMemo } from 'react';

import { Bean, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceSettlementType, SETTLEMENT_TYPES } from './settlement.types';

const radioGroupItems: RadioGroupItem<MedicalServiceSettlementType>[] = SETTLEMENT_TYPES.map((type) => ({
   id: type,
   label: medicalServiceTranslationKeys.shared.settlementType.field.map[type],
}));

type MedicalServiceSettlementTypeFieldProps = FieldControllerProps<
   'settlementType',
   MedicalServiceSettlementType | null
> & {
   readonly disabled?: boolean;
};

export const MedicalServiceSettlementTypeField = (props: MedicalServiceSettlementTypeFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required,
      };
   }, [props.required]);

   return (
      <RadioGroup
         testId={props.name}
         label={medicalServiceTranslationKeys.shared.settlementType.field.label}
         controller={props.register(props.name, validationRules)}
         items={radioGroupItems}
         horizontal
         disabled={props.disabled}
      />
   );
};
